import type { TransactionOperation } from "."
import { checkWhetherAfterPhase } from "../../phase"

export const checkWhetherAreasAreEditable: TransactionOperation<
  undefined,
  boolean
> = (transactors) => {
  const roofAttributesPhaseIsOver = checkWhetherAfterPhase(
    transactors,
    `Roof Attributes`,
  )
  const youMayEditAreas = !roofAttributesPhaseIsOver

  return youMayEditAreas
}
